export const addGiftCardOnCart = `
  mutation AddAwGcProductToCart($giftCardItem: addAwGcProductToCartInput) {
    addAwGcProductToCart(input: $giftCardItem) {
      cart {
        is_virtual
      }
    }
  }`
